/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Button, Form, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-datepicker";
import moment from 'moment';
import Excel from 'assets/CSV.svg'


// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { adminReport, reportsLocationList,adminSellerReport,adminBuyerReport,adminMembershipReport } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './Admin.scss';
import { NoData } from 'features/components/redirect/NoData';
/**
 * this page is used to show sale item report in table
 * 
 * @param props
 * 
 * @return  sales list html code
 * 
**/

export default class AdminReport extends Component {
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            starttime:{ field: 'fromdate', value: '', op: '>=', join: 'AND'},
            endtime: { field: 'todate', value: '', op: '<=', join: 'AND' },
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            enableSearchData : false,
            modal: false,
            tableData: [],
            salesDetails: {},
            category: [],
            sales: [],
            issearch: false,
            saleid: { value: '', valid: false, error: '' },
            locations: [],
            isdisabled: false,
            location: '',
            locationlength:0,
            isActiveCheckbox : "",
            isDateFromCheckBox: "",
            DateCheckBoXValue: '',
            currentDate : '',
            SearchButton : false,
            locationAllSelected: false,
            csvColumn: [],
            errorMsg: false,
            user: {
                totaluser: '',
                registeredUsers: '',
                profileCompleted: '',
                accountCreated: '',
                suspendedUsers: '',
            },
            membership: {
                totalSubscibers: '',
                subscribersCount: '',
                newSubscibersCount: '',
                expirySubscibersCount: '',
                expiredSubscibersCount:'',
                totalRevenue: '',
            },
            sales: {
                totalSalesClosed: '',
                totalItemSold: '',
                totalItemsNotSold: '',
                totalItems : '',
                totalItemsSoldPerscentage: ''

            },
            salesRevenue: {
                averageSalePrice: '',
                averageItemProce: '',
                totalBuyersPremium:'',
                totalItemTax: '',
                totalTax: '',
                totalSalePrice: '',
                totalSalePriceAndBP: ''
            },
            errorpageredirect: false,
            errorType: ''
        }

       
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.locations = [];

    }

    componentDidMount = () => {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }
    
    customTotalItems = (value) => {
        const res = value.totalItemsSold + value.totalItemsNotSold
        return res;
    }

    customTotalpercentage = (value) => {

        const result = value.totalItemsSold + value.totalItemsNotSold;
        const res = value.totalItemsSold / result * 100;
        return res ? `${parseFloat(res).toFixed(1)}%` : `- - -`;
        
    }

    // Total items not sold custom column
    totalItemsNotSold = (value) => {
        const res = value.totalItemsNotSold
        return res
    }
    // Total items sold custom column
    totalItemsSold = (value) => {
        const res = value.totalItemsSold 
        return res
    }
    // Total SalesClosed custom column
    totalSalesClosed = (value) => {
        const res = value.totalSalesClosed
        return res
    }
    // Total totalUserCount custom column
    totalUserCount = (value) => {
        const res = value.totalUserCount
        return res
    }
    // Total newUserRegistrations custom column
    newUserRegistrations = (value) => {
        const res = value.newUserRegistrations
        return res
    }

    setEndDate() {
        let end_date = moment().subtract(1, "days").endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.setState({
            currentDate : end_date
        },()=>{
            this.searchEnable()
        })
    }
    
    onChangeCheckBox = (event,date) => {
        if(event === this.state.isActiveCheckbox){
            this.setState({
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                DateCheckBoXValue: '',
            })
        }
        else{
            this.setState({
                isActiveCheckbox: event,
                isDateFromCheckBox: true,
                DateCheckBoXValue: date,
            },()=>{
                this.setState({
                    ...this.state,
                    issearch: true,
                    search: {
                        ...this.state.search,
                        starttime: {
                            ...this.state.search['starttime'],
                            value: ''
                        },
                        endtime: {
                            ...this.state.search['endtime'],
                            value: ''
                        },
                      /*   ['starttime']: {
                            ...this.state.search['starttime'],
                            value: ''
                        },
                        ['endtime']: {
                            ...this.state.search['endtime'],
                            value: ''
                        }, */
                    }
                })
            })  
        }
        this.setEndDate() 
    }

    // Enable search button according to required fields
    searchEnable() {
        let { locationAllSelected } = this.state
        if(Boolean(this.state.search.locationid.value) || locationAllSelected) {
            if(this.state.DateCheckBoXValue && this.state.currentDate) {
                this.setState({
                    SearchButton: true
                })
            }
            else if(this.state.search.starttime.value && this.state.search.endtime.value) {
                this.setState({
                    SearchButton: true
                })
            } 
            else{
                this.setState({
                    SearchButton: false
                })
            }  
        }
        else {
            this.setState({
                SearchButton: false
            })
        }
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if(event.target.value==='all'){
            this.setState({
                ...this.state,
                issearch: true,
                isdisabled: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            })
        }
        if(event.target.name === 'locationid'){
        this.setState({
            ...this.state,
            issearch: true,
            isdisabled: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: Number(eventValue)
                }
            }
        }, () => {
            if(event.target.value === 'All') {
                this.setState({
                    locationAllSelected: true
                },()=>{
                    this.searchEnable()
                }) 
            }
            else{
                this.setState({
                    locationAllSelected: false
                },()=>{
                    this.searchEnable()
                })
            }
            if(event.target.value === '')
            this.checkSearch();                
        });}
        else{
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
    }

    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            isActiveCheckbox: '',
            isDateFromCheckBox: false,
            DateCheckBoXValue: '',
            currentDate: '',
            locationAllSelected: false,
            SearchButton: false,
            enableSearchData: false,
            errorMsg: false
        }, () => {
        });
    }

    // handle enter key search
    // _handleKeyDown = (e) => {
    //     if (e.key === 'Enter') {
    //         this.serachReport()
    //     }
    // }

    serachReport = async () => {

        const userFields = [
            "totalUserCount",
            "newUserRegistrations",
            "profileCompletedCount",
            "accountCompletedCount",
            "suspendCount",
            "revenueAmount",
        ];

        const membershipFields = [
            "membershipCount",
            "subscriberCount",
            "newSubscriberCount",
            "expiryCount",
            "expiredCount",
        ];

        const salesFields = [
            "totalItems",
            "totalSalesClosed",
            "totalItemsSold",
            "totalItemsNotSold",
            "avgItemPrice",
            "avgSalePrice",
            "totalSalePrice",
            "totalAmount",
            "totalBuyersPremium",
            "totalTax",
            "location",
            "totalItemTax",
        ];

        let startDate = null
            let endDate =  null
            let checkBoxEndDate = null
            let checkBoxStartDate = null

            if(this.state.search.starttime.value){
                let startDateFormat = moment(this.state.search.starttime.value).format("YYYY-MM-DD")
                startDate =  moment.tz(startDateFormat + ' 00:00:00', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
            }
            else if(this.state.DateCheckBoXValue ){
                let startDateFormat = moment(this.state.DateCheckBoXValue).format("YYYY-MM-DD")
                checkBoxStartDate =  moment.tz(startDateFormat + ' 00:00:00', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")

            }
            
            if( this.state.search.endtime.value){
                let endDateformat = moment( this.state.search.endtime.value).format("YYYY-MM-DD")
                endDate =  moment.tz(endDateformat + ' 23:59:59', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
            }
            else if( this.state.currentDate){
                let endDateformat = moment(this.state.currentDate).format("YYYY-MM-DD")
                checkBoxEndDate =  moment.tz(endDateformat + ' 23:59:59', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
            }



        var filterSearch = {
            filter: [
                { 
                    ...this.state.search.starttime, 
                    value: this.state.isDateFromCheckBox ? checkBoxStartDate : this.state.search.starttime.value 
                        ? startDate : '' 
                },
                { 
                    ...this.state.search.endtime, 
                    value: this.state.isDateFromCheckBox ? checkBoxEndDate : this.state.search.endtime.value 
                        ? endDate : '' 
                },
            ]
        };
    
                
        if (this.state.search.locationid.value) {
            filterSearch.filter.push({ ...this.state.search.locationid });
        }
    
        this.setState({ loading: true });
        const userFilter = {
            field: userFields,
            filter: filterSearch.filter,
        };
    
        const membershipFilter = {
            field: membershipFields,
            filter: filterSearch.filter,
        };
    
        const salesFilter = {
            field: salesFields,
            filter: filterSearch.filter,
        };
    
    
        try {
            const [user, sales, membership] = await Promise.all([
                axios.post(getSellerUrl(adminBuyerReport, '', true), userFilter, getSellerHeaders()),
                axios.post(getSellerUrl(adminSellerReport, '', true), salesFilter, getSellerHeaders()),
                axios.post(getSellerUrl(adminMembershipReport, '', true), membershipFilter, getSellerHeaders()),
            ]);
            let userData = user.data.data;
            let membershipData = membership.data.data;
            let salesData = sales.data.data;
            this.setState({
                enableSearchData: true,
                loading: false,
                user: {
                    totaluser: userData.totalUserCount,
                    registeredUsers: userData.newUserRegistrations,
                    profileCompleted: userData.profileCompletedCount,
                    accountCreated: userData.accountCompletedCount,
                    suspendedUsers: userData.suspendCount,
                },
                membership: {
                    totalSubscibers: membershipData.membershipCount ? membershipData.membershipCount : '0',
                    totalRevenue: userData.revenueAmount ? userData.revenueAmount : "0.00",
                    subscribersCount:  membershipData.subscriberCount ? membershipData.subscriberCount : "0",
                    newSubscibersCount:  membershipData.newSubscriberCount ? membershipData.newSubscriberCount : "0",
                    expirySubscibersCount:  membershipData.expiryCount ? membershipData.expiryCount : "0",
                    expiredSubscibersCount: membershipData.expiredCount ? membershipData.expiredCount : "0",
                },
                sales: {
                    totalSalesClosed: salesData.totalSalesClosed,
                    totalItemSold: salesData.totalItemsSold,
                    totalItemsNotSold: salesData.totalItemsNotSold,
                    totalItems : this.customTotalItems(salesData),
                    totalItemsSoldPerscentage: this.customTotalpercentage(salesData)
    
                },
                salesRevenue: {
                    averageSalePrice: this.formatSalePrice(salesData.avgSalePrice),
                    averageItemPrice: this.formatSalePrice(salesData.avgItemPrice),
                    totalBuyersPremium: this.formatSalePrice(salesData.totalBuyersPremium),
                    totalItemTax:this.formatSalePrice(salesData.totalItemTax),
                    totalTax: this.formatSalePrice(salesData.totalTax),
                    totalSalePrice: this.formatSalePrice(salesData.totalSalePrice),
                    totalSalePriceAndBP: this.formatSalePrice(salesData.totalAmount),
                }
            })
        } catch (error) {
            this.setState({
                loading: false,
                enableSearchData: false,
                errorMsg : true
            });
        }
    }
    

    /* called when search button clicked */
    enableSearch = () => {
        var filterSearch = {
            field: ["totalItems", "totalSalesClosed", "totalItemsSold", "totalItemsNotSold", "avgItemPrice", "avgSalePrice", "totalSalePrice", "totalAmount", "totalBuyersPremium", "totalTax", "location", "totalItemTax", "suspendCount","revenueAmount","accountCompletedCount","profileCompletedCount","newUserRegistrations","totalUserCount","membershipCount"],
            filter: [
                { ...this.state.search.starttime, value: this.state.isDateFromCheckBox ? this.state.DateCheckBoXValue : this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
                { ...this.state.search.endtime, value: this.state.isDateFromCheckBox ? this.state.currentDate : this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            ]
        }

        if (this.state.search.locationid.value) {
            filterSearch.filter.push({ ...this.state.search.locationid });
        }
        this.setState({
            loading: true
        })

        axios.post(getSellerUrl(adminReport, '', true), (filterSearch), getSellerHeaders()).then((res) => {
            let value = res.data.data
            this.setState({
                enableSearchData: true,
                loading: false,
                user: {
                    totaluser: value.totalUserCount,
                    registeredUsers: value.newUserRegistrations,
                    profileCompleted: value.profileCompletedCount,
                    accountCreated: value.accountCompletedCount,
                    suspendedUsers: value.suspendCount,
                },
                membership: {
                    totalSubscibers: value.membershipCount ? value.membershipCount : '0',
                    totalRevenue: value.revenueAmount ? value.revenueAmount : "0.00",
                    subscribersCount:  value.subscriberCount ? value.subscriberCount : "0",
                    newSubscibersCount:  value.newSubscriberCount ? value.newSubscriberCount : "0",
                    expirySubscibersCount:  value.expiryCount ? value.expiryCount : "0",
                    expiredSubscibersCount: value.expiredCount ? value.expiredCount : "0",
                },
                sales: {
                    totalSalesClosed: value.totalSalesClosed,
                    totalItemSold: value.totalItemsSold,
                    totalItemsNotSold: value.totalItemsNotSold,
                    totalItems : this.customTotalItems(value),
                    totalItemsSoldPerscentage: this.customTotalpercentage(value)
    
                },
                salesRevenue: {
                    averageSalePrice: this.formatSalePrice(value.avgSalePrice),
                    averageItemPrice: this.formatSalePrice(value.avgItemPrice),
                    totalBuyersPremium: this.formatSalePrice(value.totalBuyersPremium),
                    totalItemTax:this.formatSalePrice(value.totalItemTax),
                    totalTax: this.formatSalePrice(value.totalTax),
                    totalSalePrice: this.formatSalePrice(value.totalSalePrice),
                    totalSalePriceAndBP: this.formatSalePrice(value.totalAmount),
                }
            })
        }).catch(()=>{
            this.setState({
                loading: false,
                enableSearchData: false,
            })
        })

    }
    formatSalePrice = (data) => {
        const formattedPrice = parseFloat(data).toFixed(2);
        return formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    onclickCSV = () => {

        //dset admin Report data
        let csvRow = ""
        let csvHeader = ""
    
     
        let columns = [
            { name: 'Total Users', value: this.state.user.totaluser },
            { name: 'Registered Users', value: this.state.user.registeredUsers },
            { name: 'Profile Completed', value: this.state.user.profileCompleted },
            { name: 'Account Created', value: this.state.user.accountCreated },
            { name: 'Suspended Users', value: this.state.user.suspendedUsers },
            { name: 'Total Subscribers', value: this.state.membership.totalSubscibers },
            { name: 'Subscribers', value: this.state.membership.subscribersCount },
            { name: 'New Subscribers ', value: this.state.membership.newSubscibersCount },
            { name: 'Expiring Subscribers', value: this.state.membership.expirySubscibersCount },
            { name: 'Expired Subscribers', value: this.state.membership.expiredSubscibersCount },
            { name: 'Total Revenue from Subsciptions for Day', value: `$` + this.state.membership.totalRevenue },
            { name: 'Total Sales Closed', value: this.state.sales.totalSalesClosed },
            { name: 'Total Items Sold', value: this.state.sales.totalItemSold },
            { name: 'Total Items Not Sold', value: this.state.sales.totalItemsNotSold },
            { name: 'Total Items', value: this.state.sales.totalItems },
            { name: 'Total Items Percentage of Items Sold', value: this.state.sales.totalItemsSoldPerscentage },
            { name: 'Average Sales Price', value: `$` + this.state.salesRevenue.averageSalePrice },
            { name: 'Average Item Price', value: `$` + this.state.salesRevenue.averageItemPrice },
            { name: `Total Buyer's Premium`, value: `$` + this.state.salesRevenue.totalBuyersPremium },
            { name: 'Total Item Tax', value: `$` + this.state.salesRevenue.totalItemTax },
            { name: 'Total Item Tax + Total BP Tax', value: `$` + this.state.salesRevenue.totalTax },
            { name: 'Total Sale Price', value: `$` + this.state.salesRevenue.totalSalePrice },
            { name: `Total Sale Price + Buyer's Premium`, value: `$` + this.state.salesRevenue.totalSalePriceAndBP },
        ]

        let csvHeaderItem = []
        let csvRowItem = []
        columns.map((col, key) => {
            csvHeaderItem.push(col["name"])
            typeof col["value"] === 'string' ? csvRowItem.push('"' + col["value"].replace(/"/g, '""') + '"') : csvRowItem.push(col["value"]);

            // csvRowItem.push(col["value"])

        })
        csvHeader = csvHeaderItem.map(elem => { return '"' + elem + '"' }).join(",") + '\r\n'
        csvRow = csvRow + csvRowItem.join(",") + '\r\n'

        //csv download section
        let BOM = "\uFEFF";
        let csvData = BOM + csvHeader + csvRow
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', `admin-report.csv`);
        a.click()

    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr);
        row = row.replace(/""/g, '"- - - "').replace(/null/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div className="accordion-view" style={{ padding: "1% 1%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex">
                        <div>
                            {"area" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Area</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["area"]}</div>
                            </div>}
                            {"invoicenumber" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Invoice</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["invoicenumber"] != null ? "Created" : "Not Created"}</div>
                            </div>}
                            {"bidcount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Bids</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["bidcount"]}</div>
                            </div>}
                            {"viewcount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Number of Views</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["viewcount"]}</div>
                            </div>}
                            {"soldamount" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Sold Amount $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">:{row["soldamount"]}</div>
                            </div>}
                            {"tax" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Tax $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["tax"]}</div>
                            </div>}
                        </div>
                        <div>
                            {"goal" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Goal $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["goal"]}</div>
                            </div>}
                            {"value" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Value $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["value"]}</div>
                            </div>}
                            {"handling" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Handling $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["handling"]}</div>
                            </div>}
                            {"shipping" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Shipping $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["shipping"]}</div>
                            </div>}
                            {"buyerspremium" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyers Premium $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["buyerspremium"]}</div>
                            </div>}
                            {"saleprice" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Final Sale Price $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["saleprice"]}</div>
                            </div>}
                        </div>
                        <div style={{ marginLeft: "-27px", paddingRight: "60px" }}>
                            {"directbuy" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Direct Buy $</div>
                                <div style={{ color: "black", fontWeight: "bold" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["directbuy"]}</div>
                            </div>}
                            {"starttime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Item Start Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['starttime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezone']).zoneAbbr()}</div>
                            </div>}
                            {"endtime" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Item Close Date</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{tr !== "" && moment(row['endtime']).format('MM/DD/YYYY hh:mm A')} {moment.tz(row['timezone']).zoneAbbr()} </div>
                            </div>}
                            {"firstname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer First Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["firstname"]}</div>
                            </div>}
                            {"lastname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Last Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["lastname"]}</div>
                            </div>}
                            {"nickname" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer User Name</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-4px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["nickname"]}</div>
                            </div>}
                        </div>
                        <div>
                            {"email" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Email</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["email"]}</div>
                            </div>}
                            {"mobilenumber" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Phone</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["mobilenumber"]}</div>
                            </div>}
                            {"address1" in row && <div className="accordion-row-view">
                                <div className="accordion-row-head">Buyer Address</div>
                                <div style={{ color: "black", fontWeight: "bold", marginLeft: "-21px" }}>: &nbsp;&nbsp;</div>
                                <div className="accordion-row-text">{row["address1"]}</div>
                            </div>}
                        </div>

                    </div>
                    : ''}
            </div>
        );
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* set date for date input change */
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        },() => {
            this.setState({
                ...this.state,
                isActiveCheckbox: '',
                isDateFromCheckBox: false,
                DateCheckBoXValue: '',
                currentDate: ""
            },()=>{
                this.searchEnable()
            })
        });

        }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }


    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(reportsLocationList, '' , true), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
           .then(response => {
                this.locations = response[0].data.data;
                if(this.locations.length == '1'){                
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                            isdisabled:true,
                            search: {
                                ...this.state.search,
                                locationid: {
                                    ...this.state.search.locationid,
                                    value: this.locations[0].id
                                },
                            }
                        });
                }
                else{
                        this.setState({
                            ...this.state,
                            locations: ArrayValueReorder(response[0].data.data, 'title'),
                            location: this.locations[0].title,
                            locationlength:this.locations.length,
                        })
                }
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }
    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        let date = new Date()
        let Yesterday = moment().subtract(1, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Year = moment().startOf('year').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Month = moment().startOf('month').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let Week = moment(date).format('dddd') === 'Monday' ? moment().subtract(7, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss") : moment().startOf('isoWeek').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_7days = moment().subtract(7, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_30days = moment().subtract(30, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        let last_365days = moment().subtract(365, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss");
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }} id="sale-hostory-report">
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                <Col>
                                    <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                           <option value="" disabled>Please select location</option>
                                           {this.state.locationlength>1?<option value="All">All</option>:''}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale End Date From{!this.state.isActiveCheckbox ? "*" : ""}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <label>Sale End Date To{!this.state.isActiveCheckbox ? "*" : ""}</label>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "52%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>   
                                    <Col>
                                        <div className="mt-3">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="seller-search" disabled={!this.state.SearchButton} onClick={() => this.serachReport()}>Search</Button>
                                        </div>
                                    </Col>                      
                                </Row>
                                <Row style={{ width: '70%'}}>
                                    <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                 <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'yesterday'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('yesterday',Yesterday)}></div>
                                             </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Yesterday</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Yesterday'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                               <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'week' ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('week',Week)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Week to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Monday to today of current week'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'month'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('month',Month)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Month to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current month to current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                               <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'year'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('year',Year)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                 <div>Year to Date</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'First day of the current year to current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                </Row>
                                <Row style={{ width: '70%'}}>
                                    <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px' }}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_7days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_7days',last_7days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 7 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 7 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                              <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_30days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_30days',last_30days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 30 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 30 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                        <div className={`d-flex align-items-center header`}>
                                            <div style={{ marginLeft: '10px'}}>
                                                <div className={`custom-checkbox-div ${this.state.isActiveCheckbox === 'last_365days'? 'checked' : ''}`} onClick={() => this.onChangeCheckBox('last_365days',last_365days)}></div>
                                            </div>
                                            <div style={{ marginLeft: '5%'}}>
                                                <div>Last 365 days</div>
                                            </div>
                                            <div style={{ marginLeft: '4%', marginTop: '1.5px'}}>
                                               <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Past 365 days excluding current date'}</Tooltip>}>
                                                     <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i> 
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                   </Col>
                                   <Col>
                                   </Col>
                                </Row>
                            </div>
                        </Form>

                    </div>
                </div>
           
               
                {
                    this.state.loading ?
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "54vh" }}>
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="default" height="100px" width="100px" />
                        </div> :
                        this.state.enableSearchData ?
                            <>
                                <div className='mt-4' >
                                    <div style={{ float: 'right' }}>
                                        <div >
                                            <Button onClick={() => this.onclickCSV()} className="button-view" style={{ float: "right" }}>
                                                <div className="button-text" >
                                                    <img src={Excel} width="25px" height="25px" alt="excel" />Export to CSV</div>
                                            </Button>
                                        </div>
                                    </div>

                                    <div className='p-3' style={{ backgroundColor: '#BBC7D6' }}>
                                        <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                            Users :
                                            <span className='border-set' style={{ width: '50px' }}></span>
                                        </div>
                                        <div className='admin-report'>
                                            <Row className='mt-3 sections' style={{ fontWeight: 'bold' }}>
                                                <Col>Total Users   <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Users : All registered users to date'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.user.totaluser ? this.state.user.totaluser : "- - -"}</p>
                                                </Col>
                                                <Col>Registered Users  <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total New Registrations : The number of new registrations for the period selected'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.user.registeredUsers ? this.state.user.registeredUsers : "- - -"}</p>
                                                </Col>
                                                <Col>Profile Completed  <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'All registered users Profile Completed '}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.user.profileCompleted ? this.state.user.profileCompleted : "- - -"}</p>
                                                </Col>
                                                <Col>Account Created <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'All registered users Profile Completed and Payment Completed'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.user.accountCreated ? this.state.user.accountCreated : "- - -"}</p>
                                                </Col>
                                                <Col>Suspended Users <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Suspended Users - User who have been suspended during this time'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.user.suspendedUsers ? this.state.user.suspendedUsers : "- - -"}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>

                                    <div className='p-3 mt-4' style={{ backgroundColor: '#BBC7D6' }}>
                                        <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                            Membership :
                                            <span className='border-set' style={{ width: '100px' }}></span>
                                        </div>
                                        <div className='admin-report' style={{ backgroundColor: '#BBC7D6' }}>
                                            <Row className='mb-3 mt-3 sections' style={{ fontWeight: 'bold' }} >
                                                <Col>Total Subscribers <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Subscribers - Total # of all Active Subscribers'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`} style={{ whiteSpace: 'nowrap' }}>{this.state.membership.totalSubscibers ? this.state.membership.totalSubscibers : "- - -"}</p>

                                                </Col>
                                                <Col style={{ width: '50%' }}>Subscribers <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Subscribers - # of Subscriptions For Time Frame Searched'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`} style={{ whiteSpace: 'nowrap' }}>{this.state.membership.subscribersCount ? this.state.membership.subscribersCount : "- - -"}</p>

                                                </Col>
                                                <Col style={{ width: '50%' }}>New Subscribers <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'New Subscribers - # of New Subscriptions For Time Frame Searched'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`} style={{ whiteSpace: 'nowrap' }}>{this.state.membership.newSubscibersCount ? this.state.membership.newSubscibersCount : "- - -"}</p>

                                                </Col>
                                                <Col style={{ width: '50%' }}>Expiring Subscribers <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Expiring Subscribers - # of Subscriptions That Will Expire During Time Frame Searched'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`} style={{ whiteSpace: 'nowrap' }}>{this.state.membership.expirySubscibersCount ? this.state.membership.expirySubscibersCount : "- - -"}</p>

                                                </Col>
                                                <Col style={{ width: '50%' }}>Expired Subscribers <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Expired Subscribers - # of Subscriptions Expired/Ended During Time Frame Searched'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`} style={{ whiteSpace: 'nowrap' }}>{this.state.membership.expiredSubscibersCount ? this.state.membership.expiredSubscibersCount : "- - -"}</p>

                                                </Col>
                                                <Col style={{ width: '50%' }}>Subscriber Revenue <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Subscriber Revenue - $ Amount Paid for Subscriptions During Time Frame Searched'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`} style={{ whiteSpace: 'nowrap' }}>${this.state.membership.totalRevenue ? this.formatSalePrice(this.state.membership.totalRevenue) : "- - -"}</p>

                                                </Col>
                                            </Row>
                                        </div>
                                    </div>

                                    <div className='p-3 mt-4' style={{ backgroundColor: '#BBC7D6' }}>
                                        <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                            Sales :
                                            <span className='border-set' style={{ width: '50px' }}></span>
                                        </div>
                                        <div className='admin-report' >
                                            <Row className='mb-3 mt-3 sections' style={{ fontWeight: 'bold' }}  >
                                                <Col>Total Sales Closed <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Sales Closed : The total sales closed for the time period selected'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.sales.totalSalesClosed ? this.state.sales.totalSalesClosed : "- - -"}</p>

                                                </Col>
                                                <Col>Total Items Sold <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Items Sold : The total items sold for the time period selected'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.sales.totalItemSold ? this.state.sales.totalItemSold : "- - -"}</p>

                                                </Col>
                                                <Col>Total Items Not Sold <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Items Not Sold : The total items not sold for the time period selected'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.sales.totalItemsNotSold ? this.state.sales.totalItemsNotSold : "- - -"}</p>

                                                </Col>
                                                <Col>Total Items <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Items : The total of sold items + not sold items'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.sales.totalItems ? this.state.sales.totalItems : "- - -"}</p>

                                                </Col>
                                                <Col>Total Items Percentage of Items Sold <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Percentage of Items Sold : Total Items Sold / Total Items * 100'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>{this.state.sales.totalItemsSoldPerscentage ? this.state.sales.totalItemsSoldPerscentage : "- - -"}</p>

                                                </Col>
                                            </Row>


                                        </div>



                                    </div>

                                    <div className='p-3 mt-4 mb-5' style={{ backgroundColor: '#BBC7D6' }}>
                                        <div className="mb-3 mt-3" style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>
                                            Sales Revenue :
                                            <span className='border-set' style={{ width: '120px' }}></span>
                                        </div>
                                        <div className='admin-report' >
                                            <Row className='mb-3 mt-3 sections' style={{ fontWeight: 'bold' }} >
                                                <Col>Average Sales Price <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{`Average Sale Price : The total sale price + buyer's premium / by the total sales closed for the time period selected`}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>${this.state.salesRevenue.averageSalePrice ? this.state.salesRevenue.averageSalePrice : "- - -"}</p>
                                                </Col>
                                                <Col> Average Item Price <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{`Average Item Price : The total sale price + buyer's premium / by the total items sold for the time period selected`}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>${this.state.salesRevenue.averageItemPrice ? this.state.salesRevenue.averageItemPrice : "- - -"}</p>
                                                </Col>
                                                <Col>Total Buyer's Premium <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{`Total Buyer's Premium : The total buyer's premium for the time period selected`}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>${this.state.salesRevenue.totalBuyersPremium ? this.state.salesRevenue.totalBuyersPremium : "- - -"}</p>
                                                </Col>
                                                <Col>Total Item Tax <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Item Tax : The total tax on sold items for the time period selected'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>${this.state.salesRevenue.totalItemTax ? this.state.salesRevenue.totalItemTax : "- - -"}</p>
                                                </Col>
                                                <Col>Total Item Tax + Total BP Tax <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{`Total Item Tax + Total BP Tax : The total tax on sold items + total tax on buyer's premium for the time period selected`}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>${this.state.salesRevenue.totalTax ? this.state.salesRevenue.totalTax : "- - -"}</p>
                                                </Col>
                                                <Col>Total Sale Price <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{'Total Sale Price : The total sale price of all sold items for the time period selected'}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>${this.state.salesRevenue.totalSalePrice ? this.state.salesRevenue.totalSalePrice : "- - -"}</p>
                                                </Col>
                                                <Col>Total Sale Price + Buyer's Premium<OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{`Total Sale Price + Buyer's Premium : The total sale price + buyer's premium for the time period selected`}</Tooltip>}>
                                                    <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                </OverlayTrigger>
                                                    <p className={`users-details`}>${this.state.salesRevenue.totalSalePriceAndBP ? this.state.salesRevenue.totalSalePriceAndBP : "- - -"}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </> :
                            <div className="d-flex justify-content-center align-items-center" style={{ height: "54vh" }}>
                                <h5>{this.state.errorMsg ? `No results found, please try your search again` :  `Provide criteria to filter your search `}</h5>
                            </div>
                }
            </div>
        );
    }
}